import { render, staticRenderFns } from "./upload-logo.vue?vue&type=template&id=29622f2b&scoped=true&"
import script from "./upload-logo.vue?vue&type=script&lang=js&"
export * from "./upload-logo.vue?vue&type=script&lang=js&"
import style0 from "./upload-logo.vue?vue&type=style&index=0&id=29622f2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29622f2b",
  null
  
)

export default component.exports